import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Common from "./common/CommonApp";

// 개발모드시
const portMap: { [key: string]: string | undefined } = {
    www: process.env.REACT_APP_WWW_PORT,
    air: process.env.REACT_APP_AIR_PORT,
    quick: process.env.REACT_APP_QUICK_PORT,
    express: process.env.REACT_APP_EXPRESS_PORT,
    morning: process.env.REACT_APP_MORNING_PORT,
};

const App = () => {
    const [subdomain] = useState<string>("");
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const changeSubdomain = (subdomain: string) => {
        // setSubdomain(subdomain);
        const { protocol, host, port } = window.location;
        const parts = host.split(".");

        const isDevMode = parts.includes(`localhost:${port}`); // 개발모드
        const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드

        const isDevelop = isDomainDevelop || isDevMode;

        let domain = isDevelop ? (isDevMode ? `localhost:${portMap[subdomain]}` : "likeweb.co.kr") : "ilshingroup.com";

        // console.log(domain);

        const newUrl = `${protocol}//${subdomain}.${domain}`;
        // window.location.href = newUrl;
        window.open(newUrl, "_blank");
    };

    return (
        <Routes>
            <Route path="/*" element={<Common subdomain={subdomain} changeSubdomain={changeSubdomain} />} />
        </Routes>
    );
};

export default App;
